<section>
    <img width="100%" src="/assets/images/micrositio/homepage/HOME_025.jpg">
    <br>
    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
</section>
<div class="container">
    <div class="row p-5">
        <div class="col-sm-8">
            <p class="fontMS700 colorPrincipal font-40">
                MEMORIA PERÚ
            </p>
        </div>
        <div class="col-sm-4">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/presentacion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/presentacion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/presentacion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
        <div class="col-sm-12">
            <p class="font-20">
                <br>
                <span class="fontMS500 font-22 textUpper">
                    La Biblioteca Nacional del Perú cumple 200 años de existencia. Su creación en los albores de la
                    República denota la importancia de la institución para promover la igualdad, la libertad y la
                    justicia. Este compromiso se renueva en el presente, nos invita a conocer nuestro pasado y así
                    construir un destino común.
                    <br><br>
                </span>

                La plataforma digital <span class="fontMS100Italic"> Memoria Perú. Recorridos por el patrimonio de la
                    Biblioteca Nacional del Perú</span> es un espacio para conocer las colecciones bibliográficas y
                documentales que conforman el acervo histórico y cultural de nuestro país. Nos aproxima al patrimonio
                documental, amplio y diverso, que está conformado por libros, cartas, manuscritos, periódicos,
                fotografías, partituras, audios, entre otros documentos, que datan desde el periodo colonial hasta la
                actualidad.

                <br><br>
                A través de un proceso de investigación y curaduría se han delimitado temas para presentar y
                analizar los documentos con el fin de proporcionar un acercamiento crítico y sensible a nuestra
                historia cultural, social y política. <span class="fontMS100Italic">Memoria Perú</span> está
                compuesta por cuatro recorridos a través de los cuales podrá aproximarse a los documentos:


            </p>
            <ul class="font-20">
                <li> “Creadores”, dedicado a la obra y trayectoria de intelectuales, artistas y escritores;</li>
                <li> “Miradas desde el arte”, destaca las expresiones artísticas como maneras de interpretar la
                    realidad; </li>
                <li> “Comunidades imaginadas”, refiere a los movimientos culturales y sociales vinculados a la
                    construcción de las identidades; y</li>
                <li> “Transiciones y transformaciones sociales”, reflexiona sobre los procesos políticos y sociales que
                    han sido determinantes en nuestra historia.</li>

            </ul>
            <p class="font-20">
                <br><br>
                <!--<span class="fontMS500 font-22">
                    CRÉDITOS
                </span>
                <br><br>-->
                <span class="fontMS500">Jefa Institucional de la Biblioteca Nacional del Perú</span><br>
                Ana Peña Cardoza<br><br>

                <span class="fontMS500">Coordinación</span><br>
                Leandro Villalobos - Dirección del Acceso y Promoción de la Información.<br>
                Silvana Aquino - Unidad Funcional de Acceso e Innovación Digital.<br> 
                <!-- Irina Burgos - Unidad Funcional de Investigaciones, Ediciones y Formación.<br><br> -->
                <br><br>
                <span class="fontMS500">Curaduría</span><br>
                Nicole Fadellin, Roger Cáceres, Benjamín Blass.<br><br>

                <span class="fontMS500">Investigación</span><br>
                Henry Barrera, Benjamín Blass, Nelly Bobbio, Delia Córdova, Gladys Lizana, Ana María Maldonado, 
                Juan Ricardo Martínez, Gian Marco Osorio, Erika Quintanilla, Margarita Roel, Carlos Rojas, Patricia Soto.
                <br><br>

                <span class="fontMS500">Diseño gráfico</span><br>
                Luis Chumpitazi, Malkiel Moreno, Kelly Vásquez.<br><br>

                <span class="fontMS500">Diseño UX</span><br>
                Heison Espinoza<br><br>

                <span class="fontMS500">Revisión de textos </span><br>
                Gracia Angulo, Benjamín Blass, Trilce Calluco. 
                <br><br>

                <span class="fontMS500">Gestión </span><br>
                Andrea Aliaga  <br><br>

                <span class="fontMS500">Unidad Funcional de Acceso e Innovación Digital.</span><br>
                - Dirección de Acceso y Promoción de la Información <br>
                Silvana Aquino - Coordinadora, Alfredo Bashualdo, Carlos Cerdán, Malkiel Moreno, Trilce Calluco.<br><br>
                
                <span class="fontMS500">Oficina de Tecnología de la Información </span><br>
                Emilio Lachira - Jefe <br><br>

                <span class="fontMS500">Unidad Funcional de Desarrollo de Sistemas de Información - Oficina de Tecnologías de la Información</span><br>
                David Vera - Coordinador, Jeremy Farfán, Bryan Lara, Andrea Lira, Billy Tarrillo<br><br>

                <span class="fontMS500">Dirección de Protección de las Colecciones</span><br>
                Cristina Vargas - Directora<br><br>

                <span class="fontMS500">Unidad Funcional de Control y Custodia - Dirección de Protección de las Colecciones</span><br>
                Talia Choque - Coordinadora, Erika Quintanilla, Claudia Vargas, Rubén Roble <br><br>

                <span class="fontMS500">Unidad Funcional de Conservación y Digitalización - Dirección de Protección de las Colecciones </span><br>
                Diana Zapata - Coordinadora, Maribel Chamorro, Deyvi Alvarado, Juan Chávez, Jimmy Arnao<br><br>

                <span class="fontMS500">Dirección de Gestión de las Colecciones</span><br>
                Eva Bolívar - Directora <br><br>

                <span class="fontMS500">Unidad Funcional de Procesamiento de Publicaciones Digitales y Periódicas - Dirección de Gestión de las Colecciones </span><br>
                Milagros Delgado - Coordinadora, Diana Nakamura, Julio Ugaz, Silvia Gómez, Antonio Sam, Leonor Valverde, Marcos Vilcapoma
            </p>
            <br><br>
            <!--
            <div style="padding-left: 0;" class="col-sm-7">
                <p class="font-20">
                    Créditos: <br>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquam sollicitudin faucibus. Donec eu
                    purus finibus, porttitor tortor sit amet, rutrum orci. Nunc eu dictum lacus. Aenean urna velit,
                    commodo in vehicula vitae, vestibulum nec lectus. Vestibulum ante quam, pulvinar nec sagittis at,
                    pretium eu enim. Sed convallis est eu pulvinar suscipit.
                    <br><br>
                    Donec quam quam, dignissim a libero non, ultricies porttitor felis. Suspendisse accumsan pharetra
                    nisl, at aliquam quam mollis vitae. Aenean nec laoreet orci. Donec commodo elementum consectetur.
                    <br>
                </p>
            </div>
            -->
        </div>
    </div>
</div>